import { render, staticRenderFns } from "./PopupCourseDelete.vue?vue&type=template&id=27812a4e&scoped=true&"
import script from "./PopupCourseDelete.vue?vue&type=script&lang=ts&"
export * from "./PopupCourseDelete.vue?vue&type=script&lang=ts&"
import style0 from "./PopupCourseDelete.vue?vue&type=style&index=0&id=27812a4e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27812a4e",
  null
  
)

export default component.exports